import React from 'react';
import { SectionLabel } from './SectionLabel';
export const yelpAdsFaq = [{
  question: 'Is Yelp advertising worth it?',
  answer: "Depends on the trade. It works best for the calls that can't wait, like a furnace that just died or a roof that's leaking tonight. It works less well if most of your business already comes from repeat customers or referrals. Kevin ran Yelp ad accounts for home service businesses before Viridia existed, so campaigns here get built and managed against jobs booked, not clicks."
}, {
  question: 'How much does Yelp advertising cost?',
  answer: "There's no flat rate card. Yelp runs on an auction, so cost per lead moves with your trade and how many other businesses in your area are bidding on the same searches. Ad management gets added to your plan as a custom quote based on your actual budget and platforms. Ask on the call and we'll walk through real numbers for your market instead of a made up range."
}, {
  question: 'How do Yelp ads work?',
  answer: "Your business shows up higher in relevant Yelp search results and on other businesses' pages in your category, up to a monthly budget you set. It's paid placement on top of whatever your organic Yelp presence already earns, not a replacement for it."
}];

/* 2026-09-10 (compliance, Kevin): the third answer previously closed with
   "Review count and response time still matter." Removed -- not a claim
   about managing reviews, but Yelp has now flagged Viridia for
   review-related copy twice, so no review references stay on this page
   even factual ones about Yelp's own ranking factors. */
export function YelpAdsFaq() {
  return <section id="yelp-advertising" className="border-b border-[#1a1a1a] bg-[#0c0c0c]" data-id="element-857" data-mp="2jidkxye6vsn8">
      <div className="mx-auto w-full max-w-3xl px-6 py-20 lg:py-28" data-id="element-858" data-mp="25iueda110pd1">
        <SectionLabel data-id="element-859" data-mp="25jnnuirddsyv">Yelp advertising</SectionLabel>
        <h2 className="mt-6 max-w-2xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-860" data-mp="29kz4hys9n3ux">
          Straight answers on Yelp ads, from someone who used to sell them.
        </h2>
        <p className="mt-5 max-w-xl text-sm leading-relaxed text-neutral-500" data-id="element-861" data-mp="bai6cnfctcvd">
          Kevin worked at Yelp before founding Viridia, and Viridia is a certified Yelp
          advertising partner today. Here's the honest version of what most agencies won't tell
          you.
        </p>

        <div className="mt-12 space-y-8 border-t border-[#1c1c1c] pt-10" data-id="element-862" data-mp="z0clxcr25fjb">
          {yelpAdsFaq.map(item => <div key={item.question} data-id="element-863" data-mp="u18bkisedbre">
              <h3 className="text-lg font-semibold text-white" data-id="element-864" data-mp="u2ay6eioss1i">{item.question}</h3>
              <p className="mt-3 text-sm leading-relaxed text-neutral-400" data-id="element-865" data-mp="p13vgtveij1p">{item.answer}</p>
            </div>)}
        </div>
      </div>
    </section>;
}